// @flow
import TalkingBubble from "./TalkingBubble";

export default TalkingBubble;
